function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
export function isPortkeyApp() {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
    return false;
  } else {
    return window.navigator.userAgent.includes('Portkey');
  }
}